// @noflow

/**
 * Carousel group types for /carousel_group/{group_type}.json endpoint
 */
export const CarouselGroupType = {
  Shows: 'shows',
  Movies: 'movies',
  Family: 'family',
  Latino: 'latino',
  Franchises: 'franchises',
  Home: 'home',
  Featured: 'featured',
  Purchases: 'purchases',
  Dvr: 'dvr',
};

export const DEFAULT_CAROUSEL_ITEMS = 15;
